// extracted by mini-css-extract-plugin
export default {"wrapper":"bv-z","fullName":"cv-z"};